import {Card} from "../../../../../components/card/card.jsx";
import MaterialsHomeActionItems from "../utils/materials-home-action-items.js";
import ActionCard from "../../../sos/sos-home/components/sos-home-action-card.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import {classNameUtils} from "../../../../../utils/class-name-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {DASH_BREAKPOINTS} from "../../../../../utils/responsive-graph.js";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import useHasPermission from "../../../../../hooks/use-has-permission.js";

const customStyle = classNameUtils.cardVariants("customMenu");
const MaterialsHomeActions = () => {
  const hasPermission = useHasPermission();
  const navigate = navigateHook();
  const vw = useGraphViewportWidth();
  const isCompact = vw < DASH_BREAKPOINTS.desktop;
  const items = MaterialsHomeActionItems.optionsToUser(hasPermission);

  return(
    <>
      <Card className="col-span-4 flex flex-col">
        <Card.Header className={customStyle.header}>
          <Card.Title className={customStyle.title}>Ações</Card.Title>
        </Card.Header>
        <Card.Body className={customStyle.body}>
          <SentryRow className={"h-full auto-rows-fr " + (isCompact ? "grid-cols-4!" : "grid-cols-5!")}>
            {
              items.map((item, index) =>
                <ActionCard
                  key={index}
                  reactIcon={item.reactIcon}
                  icon={item.icon}
                  title={item.title}
                  subtitle={item.subTitle}
                  onClick={() => navigate(item.devUrl, item.url, true)}
                  smallSub={item.smallSub}
                />)
            }
          </SentryRow>
        </Card.Body>
      </Card>
    </>
  )
}

export default MaterialsHomeActions;
